export default "__VITE_ASSET__CDBnsGhb__"